<template>
  <div id="operationLog"
       class="operation-log">
    <second-menu-link-content>
      <template v-slot:header>
        <span>操作日志</span>
      </template>
      <template v-slot:content>
        <div class="table">
          <el-table class="table-container"
                    :data="userOperationList"
                    @cell-click="onCellClick">
            <el-table-column label="登录账号"
                             prop="account"></el-table-column>
            <el-table-column label="联系人"
                             prop="contact"></el-table-column>
            <el-table-column label="部门名称"
                             prop="department"></el-table-column>
            <el-table-column label="最后登录时间"
                             prop="time"
                             width="200"></el-table-column>
            <el-table-column label="登录日志"
                             prop="logDetail"></el-table-column>
            <el-table-column label="操作记录"
                             prop="recordDetail"></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <pagination-tpl @queryChange="handleQueryChange"
                          :total="userOperationTotal"></pagination-tpl>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationTpl from 'base/PaginationTpl';
import { formaTimeToSecond } from 'common/js/util.js';
import DBSiteLog from 'models/db/site-log.js';
const dbSiteLog = new DBSiteLog();
export default {
  data() {
    return {
      // 默认当前页
      currentPage: 1,
      // 用户操作列表
      userOperationList: [],
      // 用户操作总条数
      userOperationTotal: 0
    };
  },
  methods: {
    onCellClick(row, column, cell, event) {
      if (column.property === 'logDetail') {
        // 点击了跳转至某个账号所有登录日志列表页
        this.$router.push({
          path: `/admin/home/log/login-detail`,
          query: {
            userId: row.userId
          }
        });
      } else if (column.property === 'recordDetail') {
        // 点击了跳转至某个账号所有操作记录列表页
        this.$router.push({
          path: `/admin/home/log/operation-detail`,
          query: {
            userId: row.userId
          }
        });
      }
    },
    handleQueryChange(query) {
      // 拿到查询参数以后，开始请求数据
      this._getUserRecordList(query.currentPage);
    },
    _getUserRecordList(currentPage) {
      dbSiteLog.getUserRecordList(currentPage).then(res => {
        let { totalNum, items } = res.result;
        this.userOperationTotal = totalNum;
        this.userOperationList = [];
        items.map(item => {
          const time = item.time ? formaTimeToSecond(item.time) : '------';
          this.userOperationList.push({
            userId: item.id,
            account: item.username,
            contact: item.head,
            department: item.departmentName,
            time: time,
            logDetail: '详情',
            recordDetail: '详情'
          });
        });
      });
    }
  },
  created() {
    // 获取数据
    this._getUserRecordList(this.currentPage);
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.operation-log {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
}
</style>

<style lang="scss">
#operationLog {
  .el-table {
    .el-table__header {
      .has-gutter {
        tr {
          th {
            color: #606266;
            background: rgba(245, 247, 250, 1);
          }
        }
      }
    }
    .el-table__body {
      tbody {
        tr {
          td:nth-child(5),
          td:nth-child(6) {
            .cell {
              color: #3d74f2;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
